<template>
<div class="wrap">
	<img src="../assets/404.gif" width="400" height="300" alt="">
	<div class="main-title">
		{{$t('common.not_found_title')}}
	</div>
	<div class="main-text">
		{{$t('common.not_found_text')}}
	</div>
</div>
</template>

<script>
export default {
}
</script>

<style scoped>
.wrap {
	width: 100%;
	height: 100%;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}
.main-title {
	font-size: 25px;
	font-weight: bold;
	color: #222d39;
}
.main-text {
	line-height: 38px;
	color: #3e4854;
	font-weight: 300;
	font-size: 19px;
}
</style>
